// extracted by mini-css-extract-plugin
export var backBtn = "CustomerNumberLoginForm-module--backBtn--O9r2i";
export var description = "CustomerNumberLoginForm-module--description--EeJfp";
export var formField = "CustomerNumberLoginForm-module--formField--TxpWr";
export var headline = "CustomerNumberLoginForm-module--headline--t8gJH";
export var loginBtn = "CustomerNumberLoginForm-module--loginBtn--SLRR6";